import React from "react";
import Ship from "../Assets/ship.png";

const TrackOrder = () => {
  return (
    <div className=" mt-12 ">
      <img className="mx-auto" src={Ship} alt="banner-2" />
      <div className="text-4xl text-center font-extrabold tracking-tight text-black md:text-5xl lg:text-6xl mb-32">
        COMING SOON
      </div>
    </div>
  );
};

export default TrackOrder;
